"use client"

import Link from "next/link"
import { SearchIcon, X } from "lucide-react"

import { useRecentlySearchedStore } from "./recently-searched-store"

export const RecentlySearches = () => {
  const keywords = useRecentlySearchedStore((state) => state.keywords)
  const removeKeyword = useRecentlySearchedStore((state) => state.removeKeyword)
  const clearKeywords = useRecentlySearchedStore((state) => state.clearKeywords)

  if (keywords.length === 0) {
    return null
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-sm font-medium">Tìm kiếm gần đây</h3>
        <button
          onClick={() => {
            clearKeywords()
          }}
          className="text-xs text-blue-600 hover:text-blue-700 font-semibold"
        >
          Xóa hết
        </button>
      </div>
      <ul className="flex flex-wrap gap-2">
        {keywords.map((keyword) => (
          <li key={keyword} className="group relative">
            <Link
              href={`/search?keyword=${encodeURIComponent(keyword)}&type=dish`}
              className="px-3 py-1 bg-gray-100 rounded-full text-sm inline-flex items-center gap-1.5 hover:bg-gray-200 pr-7"
              rel="search"
            >
              <SearchIcon className="h-3.5 w-3.5 text-gray-500" />
              {keyword}
            </Link>
            <button
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                removeKeyword(keyword)
              }}
              className="absolute right-1.5 top-1/2 -translate-y-1/2 transition-opacity"
              aria-label="Remove search"
            >
              <X className="h-3.5 w-3.5 text-gray-400 hover:text-gray-600" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
